import _ from 'lodash';
import { ENUM_REGEX } from '@/trendData/trendData.constants';
import { t } from 'i18next';
import { NULL_PLACEHOLDER } from '@/tableBuilder/tableBuilder.constants';

export function getCellValue(
  textValue: string | undefined | boolean,
  showUnit: boolean,
  units: string | undefined,
): string {
  if (_.isNil(textValue)) {
    return '';
  } else if (_.isBoolean(textValue)) {
    return t(`ADMIN.CONFIGURATION.${textValue ? 'LABEL_VALUE_TRUE' : 'LABEL_VALUE_FALSE'}`);
  }

  const match = textValue?.toString().match(ENUM_REGEX);
  if (match) {
    return match[2];
  }

  if (showUnit && !_.isEmpty(units) && units !== 'string' && textValue !== NULL_PLACEHOLDER) {
    return `${textValue} ${units}`;
  } else {
    return textValue;
  }
}

// This function is used to fix the issue where stopPropagation does not work as expected in React.
// see https://stackoverflow.com/questions/63964553/ag-grid-prevent-onrowclicked-event-when-clicking-icon-inside-cell
//
// stopPropagation does not work in ag-grid as expected because React uses a synthetic event system.
// the gist is that the event that you receive from the onClick callback is React's synthetic event
// which is a wrapper of the native event. Calling stopPropagation() from a synthetic event will
// not stop the real event from bubbling up and it is a quirk of the React framework for a long time.
// https://legacy.reactjs.org/blog/2020/08/10/react-v17-rc.html
export function fixStopPropagationByPreventingDefault(event: any) {
  event?.preventDefault();
}
